//
import Service from '@/services/api/service'
import CustomerReceivablePaymentDetailModel from '@/models/POS/PosDetailCustomerReceivablePayment'

//
import headers  from './headers'

//
export default class extends Service {

    //
    static headers  = headers
    
    //
    static model = CustomerReceivablePaymentDetailModel
}
